import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading/loading.service';
import { CarrierService } from '../../services/carrier/carrier.service';
import { AlertService } from '../../services/alert/alert.service';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-nonusetsp',
    templateUrl: './non-use-tsp.component.html',
    styleUrls: ['./non-use-tsp.component.css'],
    standalone: false
})
export class NonUseTspComponent implements OnInit {

  format = 'MM/dd/yyyy';
  locale = 'en-US';
  paginationPageSize: any = 20;
  public rowData: any;
  columnAPI: any;
  gridAPI: any;
  nonuseTSPOptions: GridOptions = this.initializeGridOptions();
  nonuseTSPColumnDefs: any = [
    { headerName: 'SCAC', field: 'scac', filter: 'agTextColumnFilter', sortable: true, width: 50,
      cellClass: 'textFormat'},
    { headerName: 'TSP Name', field: 'scacName', filter: 'agTextColumnFilter', sortable: true},
    { headerName: 'POC First Name', field: 'pocFirstName', filter: 'agTextColumnFilter', sortable: true, width: 150},
    { headerName: 'POC Last Name', field: 'pocLastName', filter: 'agTextColumnFilter', sortable: true, width: 150},
    { headerName: 'POC Email', field: 'pocEmail', filter: 'agTextColumnFilter', sortable: true, width: 150},
    { headerName: 'Approval Types',
      field: 'approvalType',
      filter: 'agTextColumnFilter', sortable: true},
    { headerName: 'Deleted Date',
      valueGetter: (params) => {
        return params.data.deletedDate ? formatDate(params.data.deletedDate, this.format, this.locale) : 'Not Available';
      },
      filter: 'agTextColumnFilter', sortable: true, width: 100},
    { headerName: 'Notes', field: 'message', filter: 'agTextColumnFilter', sortable: true, width: 150}
  ];
  constructor(private carrierService: CarrierService,
              private loadingService: LoadingService,
              private alertService: AlertService) {}

  ngOnInit(): void {
    this.onLoadNonUseTSP();
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        this.gridAPI = params.api;
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  onLoadNonUseTSP() {
    this.loadingService.show();
    this.carrierService.getNonUseTSP().subscribe(data => {
        this.rowData = data;
      }, (error) => {
        this.alertService.error('No records found for the search criteria ');
        this.loadingService.hide();
      }, () => {
        this.loadingService.hide();
      }
    );
  }

  onGridReady(params: any) {
    this.gridAPI = params.api;
    this.columnAPI = params.columnApi;
    this.gridAPI.sizeColumnsToFit();
  }

}
